import { render, staticRenderFns } from "./filePre.vue?vue&type=template&id=42aed6ce&scoped=true&"
import script from "./filePre.vue?vue&type=script&lang=js&"
export * from "./filePre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aed6ce",
  null
  
)

export default component.exports